import classnames from "classnames";
import React, { useRef, useMemo } from "react";
import omit from "omit.js"
import { TabPaneProps } from './iTabs'
import {getNid} from "../../wui-core/src/index"
import ReactDOMCompat from '../../wui-core/src/reactCompat';

const TabPaneInner: React.FC<TabPaneProps> = (props) => {
    const { className, destroyInactiveTabPane, active, forceRender, rootclsPrefix, style, children, placeholder = null, ...others } = props;

    // 使用 ref 跟踪是否曾经激活过
    const isActivedRef = useRef(false);

    if (active) {
        isActivedRef.current = true;
    }

    const cls = useMemo(() => {
        const clsPrefix = `${rootclsPrefix}-tabpane`;
        let className = '';
        ReactDOMCompat.startTransition(() => {
            className = classnames({
                [clsPrefix]: 1,
                [`${clsPrefix}-inactive`]: !active,
                [`${clsPrefix}-active`]: active,
                [`${props.className}`]: props.className
            });
        });
        return className;
    }, [rootclsPrefix, active, props.className]);

    // 缓存渲染条件计算
    const isRender = useMemo(() => {
        return destroyInactiveTabPane ? active : isActivedRef.current;
    }, [destroyInactiveTabPane, active]);

    // 缓存 nid 计算
    const nid = useMemo(() => {
        const adapterNid = getNid(props);
        return adapterNid?.nid ? adapterNid?.nid + "_body" : others?.nid;
    }, [props, others?.nid]);

    // 缓存其他属性
    const otherProps = useMemo(() => {
        return omit(others, ["closeIcon", "tab"]);
    }, [others]);

    return (
        // @ts-ignore
        <div
            style={style}
            role="tabpanel"
            aria-hidden={active ? "false" : "true"}
            className={cls}
            {...otherProps}
            // @ts-ignore
            nid={nid}
        >
            {isRender || forceRender ? children : placeholder}
        </div>
    );
};

const TabPane = React.memo(TabPaneInner, (prevProps, nextProps) => {
    const keys: (keyof TabPaneProps)[] = ['active', 'forceRender', 'destroyInactiveTabPane', 'className', 'style'];
    if (keys.some(key => prevProps[key] !== nextProps[key])) return false;
    if ((nextProps.active || nextProps.forceRender) && prevProps.children !== nextProps.children) return false;
    return true;
});
TabPane.displayName = 'TabPane';

export default TabPane;
